_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[28],{

/***/ "6F0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cIxt");




var ContentPage = function ContentPage() {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_2__[/* CmsContentPage */ "e"], {});
};

/* harmony default export */ __webpack_exports__["default"] = (ContentPage);

/***/ }),

/***/ "axTd":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/content",
      function () {
        return __webpack_require__("6F0W");
      }
    ]);
  

/***/ })

},[["axTd",1,2,4,6,5,3,0]]]);